import { css, cx } from 'emotion';

import {
	lightGrey,
	darkGrey,
	headingXLarge,
	headingMedium,
	museo500,
	mobileMaxWidthBreakpoint,
	desktopMaxWidthBreakpoint,
	tabletPortraitMaxWidthBreakpoint,
	tabletLandscapeMaxWidthBreakpoint,
} from 'inside-out/global-styles';

import DropDownIcon from 'inside-out/images/dropdown-icon.svg';

export const locationSelectorStyle = css({
	display: 'none',
	[`@media (min-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
		maxWidth: desktopMaxWidthBreakpoint,
		height: '106px',
		width: '100%',
		margin: '0 auto',
		padding: '0 20px',
		display: 'table',
	},
});

export const locationSelectorInnerStyle = css({
	display: 'table-cell',
	verticalAlign: 'middle',
	'& label': {
		...museo500,
	},
	'& select': {
		marginLeft: '20px',
		border: `1px solid ${lightGrey}`,
		color: darkGrey,
		borderRadius: '4px',
		fontSize: '16px',
		lineHeight: '18px',
		padding: '14px 36px 14px 18px',
		appearance: 'none',
		cursor: 'pointer',
		background: `#F6F6F6 url(${DropDownIcon}) no-repeat calc(100% - 16px) center`,
	},

	[`@media (min-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
		'& label': {
			fontSize: '18px',
			lineHeight: '22px',
		},
		'& select': {
			width: '200px',
		},
	},
	[`@media (min-width: ${tabletLandscapeMaxWidthBreakpoint}px)`]: {
		'& label': {
			fontSize: '22px',
			lineHeight: '27px',
		},
		'& select': {
			minWidth: '300px',
		},
	},
});

export const tabPageWrapper = css({
	borderTop: `1px solid ${lightGrey}`,
	backgroundColor: '#F6F6F6',
	width: '100%',
	[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
		paddingTop: 0,
		borderTop: 'none',
	},
});

export const titleStyle = cx(
	headingXLarge,
	css({
		width: '525px',
		[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
			lineHeight: '47px',
		},
		[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
			lineHeight: '23px',
			width: '286px',
		},
	})
);

export const subTitleStyle = cx(
	headingMedium,
	css({
		[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
			fontSize: '16px',
			lineHeight: '18px',
		},
	})
);

export const locationDropdownStyle = css({
	'& label': {
		...museo500,
		display: 'block',
	},
	'& select': {
		marginTop: '20px',
		width: '100%',
		display: 'block',
		border: `1px solid ${lightGrey}`,
		color: darkGrey,
		borderRadius: '4px',
		fontSize: '16px',
		lineHeight: '18px',
		padding: '14px 36px 14px 18px',
		appearance: 'none',
		cursor: 'pointer',
		background: `#F6F6F6 url(${DropDownIcon}) no-repeat calc(100% - 16px) center`,
	},

	[`@media (min-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
		display: 'none !important',
	},
});



// WEBPACK FOOTER //
// ./src/page-styles/support-organisations/index.js